<template>
    <div class="calendar-picker">
        <div class="header">{{ $t("tables.filter") }}</div>
        <div class="search-wrapper">
            <a-input-search v-model:value="search" :placeholder="$t('message.inputSearchText')" />
        </div>

        <div class="list-item" @click="changeCalendar('my')">{{ $t("calendar.myEvents") }}</div>
        <div class="list-item" @click="changeCalendar('everyone')">{{ $t("calendar.everyoneEvents") }}</div>
        <div class="group-title">{{ $t("calendar.agents") }}</div>
        <div class="list-items">
            <div class="list-item" v-for="user in getFilteredUsers()" @click="changeCalendar(user._id)">
                <AgentAvatar :size="25" :userID="user._id" :font-size="15" single-char />
                <span>{{ user.name }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import AgentAvatar from "../../../../../components/common/AgentAvatar.vue";
import { mapGetters, mapState } from "vuex";

export default Vue.extend({
    name: "CalendarPicker",
    components: {
        AgentAvatar,
    },
    props: {
        value: {
            type: String,
            default: "my",
        },
    },
    data() {
        return {
            search: "",
            clone: this.value,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            users: (state) => state.user.users.data,
        }),
        ...mapGetters({}),
    },
    methods: {
        changeCalendar(id) {
            this.clone = id;
        },
        getFilteredUsers() {
            const q = (this.search || "").trim().toLowerCase();
            if (q.length === "") {
                return this.users;
            }
            return this.users.filter((user) => user.name.toLowerCase().includes(q));
        },
    },
    watch: {
        value(val) {
            if (val !== this.clone) {
                this.clone = val;
            }
        },
        clone(val) {
            this.$emit("input", val);
        },
    },
});
</script>

<style scoped lang="scss">
.calendar-picker {
    display: flex;
    flex-direction: column;
    width: 300px;

    .header {
        display: flex;
        flex-flow: column;
        color: var(--color-text-strong-default);
        background-color: var(--color-bg-neutral-low-default);
        outline-style: none;
        cursor: default;
        justify-content: center;
        align-items: center;
        padding: 8px;
        width: 100%;
    }

    .search-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 20px;
    }

    .group-title {
        display: flex;
        flex-flow: column;
        color: var(--color-text-strong-default);
        background-color: var(--color-bg-neutral-low-default);
        outline-style: none;
        cursor: default;

        font-weight: 600;
        justify-content: left;
        text-align: left;
        text-transform: uppercase;
        padding: 8px 12px;
        font-size: 12px;
    }

    .list-item {
        display: flex;
        position: relative;
        padding: 8px 12px;
        cursor: pointer;
        transition: background-color 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
        overflow-wrap: anywhere;
        background-color: var(--color-bg-default);
        font-size: 14px;
        font-weight: 500;
        color: var(--color-text-strong-default);
        align-items: center;
        gap: 5px;
        border-bottom: 1px solid var(--color-border-default);

        &:hover {
            background: var(--color-bg-hover);
        }
    }

    .list-items {
        overflow-y: auto;
        height: 200px;
    }
}
</style>
